<div class="goto-marketplace d-flex align-items-center cursor_pointer" [ngClass]="regStatue ? 'cartBox-max-width' : 'cartBox-width'" *ngIf="isCartBtn" (click)="getPriceInfo()">
    <div class="custom-cart">
        <div class="cursor_pointer px-0" >
            <!--<span><img src="assets/img/cart-shopping-solid.svg" class="cart--icon" ></span>-->
            <span>
                <svg class="cart--icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" triggers="mouseover:mouseleave" tooltipClass="count-tooltip-market-not" ngbTooltip="{{MPCmnCartTip}}">
                    <path [style.fill]="isCartActive ? '#17a9e8' : '#ccc'" d="M0 24C0 10.7 10.7 0 24 0L69.5 0c22 0 41.5 12.8 50.6 32l411 0c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3l-288.5 0 5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5L488 336c13.3 0 24 10.7 24 24s-10.7 24-24 24l-288.3 0c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5L24 48C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"/>
                </svg>
            </span>
        </div>
        <div class="cart_badge cursor_pointer count_bellIcon mt-3 px-0">
            <span class="badge rounded-pill bg-danger text-white text--ellipsis">{{matchedNdcCount}}</span>
        </div>
    </div>
    <div [ngClass]="isCartActive ? 'price-button-orange' : 'bg-grey'" class="price-button px-2 py-1 mr-2 text-white rounded text--ellipsis" tooltipClass="count-tooltip-market-cart-price bestPriceToolTip" ngbTooltip="{{MPBestPrice}}">
        <span>{{ bestPrice }}</span>
    </div>
    <div [ngClass]="isCartActive ? 'price-button-green' : 'bg-grey'" class="price-button px-2 py-1 text-white rounded text--ellipsis" tooltipClass="count-tooltip-market-cart-price" ngbTooltip="{{MPInCartPrice}}">
        <span>{{ inCartprice }}</span>
    </div>
</div>
<ng-template #ISMARKETPLACE let-c="close" let-d="dismiss" class="el--popup">
    <div class="market-popup-content">
        <button class="close-btn" (click)="closeModal()">&times;</button>
            <h2 class="market-header">Discover Exclusive Pricing and Save More!</h2>
            <p> Join the <span class="link">PrimeRx Market</span> to unlock special pricing and maximize your savings </p>
        <button (click)="getNavigationUrl()" class="register-btn" autofocus>REGISTER FOR NEW ACCOUNT</button> 
    </div>
</ng-template>

<ng-template #CUTOFFTIME let-c="close" let-d="dismiss" class="el--popup">
    <div class="snoozer-container">
        <div class="header">
            <button class="close-btn" (click)="closeModal()">&times;</button>
        </div>
        <div class="reminder">
            <span class="icon"><img src="assets/img/icons8-alarm-clock.gif" /></span>
            <div class="details">
                <strong>Cut-Off Time Reminder</strong>
            </div>
        </div>
        <div class="snoozer-box">
            <div *ngFor="let group of remindersToShow; let i = index">
                <div class="list" 
                    [ngClass]="{ 'snoozer-highlight': isSelectedVendor(group, vendor, i) }"
                    *ngFor="let vendor of group.vendors; let vendorIndex = index"
                    (click)="selectVendor(group, vendor, vendorIndex)">
                    <div class="item">
                        <i class="pi pi-clock chips-Cutoff-icon"></i>
                        {{ vendor | titlecase }}
                    </div>
                    <div class="status">
                        {{ calculateVendorTimeLeft(vendor) }}
                    </div>
                </div>
            </div>
        </div>
        <div class="actions">
            <div class="snooze-section1">
                <span>Click Snooze to be reminded in</span> 
            </div>
		</div>
		<div class="actions-btn">
			<div class="snooze-section2">
                <select [(ngModel)]="selectedSnooze"
                    [disabled]="!selectedVendor || selectedVendor.length === 0"
                    >
                    <option *ngFor="let opt of [5, 10, 15]" [value]="opt">
                        {{ opt }} minutes
                    </option>
                </select>
				<button class="btn btn-primary rm-padding"
                    (click)="onSnooze()"
                    [disabled]="!selectedVendor || selectedVendor.length === 0"
                    >Snooze
                </button>
			</div>
			<div class="snooze-section3"> 
				<button class="btn btn-primary rm-padding" (click)="onDismiss()" [disabled]="!selectedVendor || selectedVendor.length === 0">Dismiss</button>
				<button class="btn btn-primary rm-padding" (click)="onDismissAll()">Dismiss All</button>
			</div>
        </div>
    </div>
</ng-template>

<ng-template #BESTDEAL let-c="close" let-d="dismiss" class="el--popup">
        <div class="modal-header">
            <h4 class="modal-title">Best Deal on Market</h4>
            <button type="button" [tabindex]="-1" class="close" aria-label="Close">
                <span aria-hidden="true" class="close-button" (click)="closeHoaPopUp();">&times;</span>
            </button>
        </div>
        <div class="remider--container">
            <div class="remider-sec">
                <div class="width_16rem height_36px">
                </div>                
                <div class="custom-cart custom-cart-inPopup" (click)="getNavigationUrl()">
                    <div class="cursor_pointer px-0" >
                        <span><img src="assets/img/cart-shopping-solid.svg" class="cart--icon" tooltipClass="count-tooltip-market-cart" placement="left" ngbTooltip="{{MPQtyByNDC}}"></span>
                    </div>
                    <div class="cart_badge cursor_pointer count_bellIcon mt-3 px-0">
                        <span class="badge rounded-pill bg-danger text-white" >{{matchedNdcCount}}</span>
                    </div>
                </div>
            </div>
            <div class="remider--header">
                <span></span>
                <span>Wholesaler</span>
                <span>NDC</span>
                <span>Pack Size</span>
                <span>Qty Avl.</span>
                <span>Pack Price</span>
                <span>Expiry Date</span>
                <span>Delivery Mode</span>
                <span></span>
            </div>
            <ng-container *ngIf="bestPrinInfo.length > 0; else noResults">
                <div class="remider--body" *ngFor="let item of bestPrinInfo; let isLast = last;"  [ngClass]="{ 'last-item': isLast }">
                    <div class="product-name">
                        <span [innerHTML]="getBrandIcons(item)"></span>
                        <span class="tag" [innerHTML]="getTagWithIcon(item)"></span>
                    </div>
                    <div class="product-details items">
                        <span class="items-1"><img (error)="onImgError($event)" [alt]="'Drug Image'" [src]="item?.imgURL" class="rx-image" /></span>
                        <span class="items-2">{{ item?.Wholesaler }}</span>
                        <span class="items-3">{{ item?.NDC }}</span>
                        <span class="items-4">{{ item?.Pack_Size }}</span>
                        <span class="items-5">{{ item?.Qty_Avl }}</span>
                        <span class="items-6"><span class="price orange">${{ item?.Pack_Price }}</span></span>
                        <span class="items-7">{{ item?.Expiry_Date }}</span>
                        <span class="delivery items-8">
                        <img 
                            [src]="item?.shipImg"
                            [ngbTooltip]="item.shippingInfo ? shippingTemplate : ''"
                            [tooltipContext]="{ shipping: item.shippingInfo, wholesaler: item.Wholesaler, creditterm: item.creditTerm, shipingImg:item.shipImg }"
                            container="body" 
                            [tooltipClass]="'marketPlace--tooltip--right'" 
                            triggers="mouseover:mouseleave" 
                            [autoClose]="true" 
                            placement="right" 
                        />
                        </span>
                        <span class="delivery-action items-9">
                            <input
                                type="text"
                                name="inputQty{{item.auctionId}}"
                                required
                                maxlength="4"
                                pattern="^[0-9]{1,4}$"
                                (keypress)="allowOnlyDigits($event)"
                                (input)="onQtyChange(item)"
                                (paste)="preventPaste($event)"
                                [disabled]="!cartPrivCheck"
                                [(ngModel)]="item.inputQty"
                                #qtyInput="ngModel"
                                [title]="cartPrivCheck ? '' : noPrivMessage"
                                [ngClass]="{ 'invalid-input': qtyInput.invalid && qtyInput.touched }"
                            />
                            <button [ngClass]="cartPrivCheck ? 'orange-button' : 'bg-grey'" class="add-btn cartPrevBtn" (click)="adddCardItems(item, qtyInput);" [title]="cartPrivCheck ? '' : noPrivMessage">{{ getQtyButtonText(item) }}</button>
                        </span>
                    </div> 
                </div>
                <ng-template #shippingTemplate let-shipping="shipping" let-wholesaler="wholesaler" let-creditterm="creditterm" let-shipingImg="shipingImg">
                        <div class="shipping--main">
                            <div class="shipping-inner-head">
                                <div class="img"><img [src]="shipingImg" /></div>
                                <div class="desc-text">
                                    <span class="color-text">Shipping Options</span>
                                    <span>{{ wholesaler }}</span>
                                </div>
                            </div>
                            <div class="shipping-inner-body" *ngIf="shipping"> 
                                <div class="item-1"><span class="color-text">Cutoff: </span>{{ shipping.cutoffTime }}</div>
                                <ng-container *ngFor="let key of getKeys(shipping.shippingMethods)" class="shipping-loop"> 
                                        <div class="item-1 item">
                                                <span class="color-text"> {{ shipping.shippingMethods[key].name }}: </span> 
                                                ${{ shipping.shippingMethods[key].minOrderForFree }} min or 
                                                ${{ shipping.shippingMethods[key].feeForMinOrder }} Ship Fee
                                        </div>
                                </ng-container>
                            </div>
                            <div class="shipping-footer"> 
                                <span><span class="color-text">Total in cart for the Wholesaler:</span>  ${{ shipping.total ?? '0.00' }}  </span>
                                <span><i class="fa-kit fa-file-invoice-dollar-light color-icon-text"></i>
                                    <span class="color-text icon-footer">&nbsp; Prepayment Required | Credit Terms:</span>  {{ creditterm ?? '' }}  </span>
                            </div>
                        </div>
                </ng-template>
            </ng-container>
            <ng-template #noResults>
                <p>No pricing information available.</p>
            </ng-template>
            <div class="remider--footer">
                <button class="hotkey_success" id="remiderFocus" (click)="closeHoaPopUp()" appShortcutKey [AltKey]="'c'">
                    <span>C</span> CLOSE
                </button>
            </div>
        </div>
        <div id="loader" class="cart-overlay" *ngIf="isCartLoading">
            <img src="assets/img/Animation-cart.gif" alt="Loading" class="cart-loader-gif">
        </div>
</ng-template>